import React from 'react';
import { SparkleIcon } from '../App'; // Assuming SparkleIcon is exported from App.js if you want to use it
import { Link } from 'react-router-dom'; // Will need to install react-router-dom

const DownloadPage = () => {
    const appDownloadLink = "https://github.com/Karanveerkvr/IRL-Quest-Download/"; // Replace with your actual download URL
    const appFileName = "IRL Quest"; // Replace with your desired file name

    return (
        <section id="download" className="min-h-screen flex flex-col items-center justify-center p-6 sm:p-8 text-center bg-black text-gray-300 font-mono">
            <h2 className="text-2xl sm:text-3xl font-medium text-gray-300 mb-8 flex items-center gap-2">
                <SparkleIcon className="text-blue-400" /> Download IRL Quest <SparkleIcon className="text-blue-400" />
            </h2>
            <p className="text-base md:text-lg mb-8 max-w-xl mx-auto text-gray-400">
                Ready to gamify your tasks? Download the IRL Quest app today!
            </p>

            <a
                href={appDownloadLink}
                download={appFileName}
                className="inline-flex items-center space-x-3 bg-white text-black font-semibold py-3 px-8 rounded-full shadow-lg hover:bg-gray-200 transition-colors duration-300 transform hover:scale-105"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-download">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7 10 12 15 17 10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
                <span>Download App</span>
            </a>

            <p className="text-sm text-gray-500 mt-6">
                (Click the button above, it will take you to app releases.)
            </p>

            <Link to="/" className="mt-12 text-blue-400 hover:text-blue-300 transition-colors">
                &larr; Back to Home
            </Link>
        </section>
    );
};

export default DownloadPage;